import React, { useState, useEffect } from "react";
import "./internshipcontrols.css";
import Loading1 from '../../loading_animation/loading';

const OngoingInternships = () => {
  const [ongoing, setOngoing] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [domains, setDomains] = useState([]);
  const [slots, setSlots] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.ONGOING_INTERNS}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const ongoingWithIds = data.ongoing.map((intern) => ({
            ...intern,
            id_key: intern.application_id,
          }));
          setOngoing(ongoingWithIds);
        } else {
          console.error("Error fetching ongoing interns:", data.message);
        }
      })
      .catch((err) => console.error("Network error:", err));
  }, [config]);

  const toggleSelect = (appId) => {
    setSelectedRows((prev) =>
      prev.includes(appId)
        ? prev.filter((id) => id !== appId)
        : [...prev, appId]
    );
  };

  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.INTERNSHIP_SLOT_DOMAIN}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setDomains(data.domains);
          setSlots(data.slots);
        } else {
          console.error("Error fetching domains/slots:", data.message);
        }
      })
      .catch(err => console.error("Network error:", err));
  }, [config]);

  // -------------------------
  // UPDATE EACH INTERNSHIP
  // -------------------------
  const updateInternship = async (intern) => {
    if (!config) return;

    const res = await fetch(`${config.BASE_URL}${config.UPDATE_INTERNSHIP_DETAILS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        application_id: intern.application_id,
        domain: intern.domain,
        slot: intern.slot,
        duration: intern.duration
      })
    });

    return res.json();
  };

  // -------------------------
  // UPDATE SELECTED BUTTON
  // -------------------------
  const updateSelected = async () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to update.");
      return;
    }

    setIsLoading(true);

    for (let appId of selectedRows) {
      const intern = ongoing.find((i) => i.id_key === appId);

      if (!intern) continue;

      // Validate slot if domain changed
      if (intern.domain && intern.slot === "") {
        alert(`Please select a slot for Application ID ${intern.application_id}`);
        setIsLoading(false);
        return;
      }

      await updateInternship(intern);
    }

    setIsLoading(false);
    alert("Selected rows updated successfully!");
  };

  return (
    <div className="internship-table-container">
      <h2>Ongoing Internships</h2>

      <button
        className="confirm-button"
        style={{ marginBottom: "20px" }}
        onClick={updateSelected}
      >
        Update Selected
      </button>

      <table className="internship-table">
        <thead>
          <tr>
            <th>Select</th>
            <th>Application ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>College</th>
            <th>Domain</th>
            <th>Amount</th>
            <th>Duration</th>
            <th>Applied Date</th>
            <th>Slot</th>
            <th>Start Date</th>
          </tr>
        </thead>
        <tbody>
          {ongoing.map((intern) => (
            <tr key={intern.id_key}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedRows.includes(intern.id_key)}
                  onChange={() => toggleSelect(intern.id_key)}
                />
              </td>

              <td>{intern.application_id}</td>
              <td>{intern.name}</td>
              <td>{intern.email}</td>
              <td>{intern.phone}</td>
              <td>{intern.college}</td>

              <td>
                <select
                  value={intern.domain}
                  onChange={(e) => {
                    alert("You changed the domain. Please select a new slot for this domain.");

                    const updated = ongoing.map((item) =>
                      item.id_key === intern.id_key
                        ? { ...item, domain: e.target.value, slot: "" }
                        : item
                    );
                    setOngoing(updated);
                  }}
                >
                  <option value="">Select Domain</option>
                  {domains.map((d) => (
                    <option key={d.id} value={d.internship_domain_name}>
                      {d.internship_domain_name}
                    </option>
                  ))}
                </select>
              </td>

              <td>{intern.amount}</td>

              <td>
                <select
                  value={intern.duration}
                  onChange={(e) => {
                    const updated = ongoing.map((item) =>
                      item.id_key === intern.id_key
                        ? { ...item, duration: e.target.value }
                        : item
                    );
                    setOngoing(updated);
                  }}
                >
                  <option value="">Select Duration</option>
                  <option value="one month">one month</option>
                  <option value="two months">two months</option>
                  <option value="four months">four months</option>
                  <option value="six months">six months</option>
                </select>
              </td>
              <td>{intern.submitted_at}</td>
              <td>
                <select
                  value={intern.slot}
                  onChange={(e) => {
                    const updated = ongoing.map((item) =>
                      item.id_key === intern.id_key
                        ? { ...item, slot: e.target.value }
                        : item
                    );
                    setOngoing(updated);
                  }}
                >
                  <option value="">Select Slot</option>
                  {slots.map((s) => (
                    <option key={s.id} value={s.slot_no}>
                      {s.slot_no} — {s.domain} — {s.timings} — {s.mode}
                    </option>
                  ))}
                </select>
              </td>

              <td>{intern.internship_start_date}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Loading1 />
        </div>
      )}
    </div>
  );
};

export default OngoingInternships;
